import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
interface HeroProps {
  onCTAClick: () => void;
}
export function Hero({
  onCTAClick
}: HeroProps) {
  return <section className="bg-white py-12 md:py-20" data-id="element-77">
      <div className="max-w-6xl mx-auto px-4 sm:px-6" data-id="element-78">
        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-black text-center text-gray-900 leading-tight mb-8 md:mb-12" data-id="element-79">
          Convertite en el jugador que{' '}
          <span className="text-emerald-600" data-id="element-80">necesita el equipo</span>, cuando
          el partido se complica
        </motion.h1>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="max-w-3xl mx-auto mb-8 cursor-pointer" onClick={onCTAClick} data-id="element-81">
          <img src="https://cdn.magicpatterns.com/uploads/35yVn4Y1DqodqTe56QcALw/ChatGPT_Image_Jun_18,_2026,_11_32_56_PM.png" alt="Sistema del 10 Integral" className="w-full h-auto rounded-lg shadow-2xl" data-id="element-82" />
        </motion.div>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} className="text-lg md:text-xl text-center text-gray-700 mb-8 max-w-3xl mx-auto" data-id="element-83">
          Todo lo que necesitás para dejar de improvisar y empezar a influir de
          verdad en cada partido.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.6
      }} className="flex justify-center mb-6" data-id="element-84">
          <button onClick={onCTAClick} className="bg-emerald-600 hover:bg-emerald-700 text-white font-bold text-lg px-10 py-4 rounded-lg shadow-lg transition-all duration-300 transform hover:scale-105" data-id="element-85">
            Quiero definir los partidos
          </button>
        </motion.div>

        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 0.6,
        delay: 0.8
      }} className="flex items-center justify-center gap-2 text-gray-700" data-id="element-86">
          <div className="flex gap-1" data-id="element-87">
            {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-emerald-600 text-emerald-600" data-id="element-88" />)}
          </div>
          <span className="font-semibold" data-id="element-89">
            +524 jugadores ya entrenan con el sistema
          </span>
        </motion.div>
      </div>
    </section>;
}